<ef-loading-container [observables]="[payPeriods$]"></ef-loading-container>
<ef-loading
    [processing]="showTimer"
    [processingText]="processingText"
></ef-loading>
<ef-process-detail [process]="process$ | async"></ef-process-detail>
<p-messages severity="info">
    <ng-template pTemplate>
        <ol>
            <div style="margin-left: -2rem">
                Steps for sending payroll.
            </div>
            <li>View: Click for a preview of formatted payroll details. This step is REQUIRED before sending payroll.</li>
            <li>Send: Click to send payroll period data directly to GovConPay.</li>
            <li>Login to GovConPay to review and commit payroll for the pay period.</li>
            <li>Expenses: After payroll is committed, click to import non-labor payroll expenses.</li>
            <li>Send payroll journal entry to QuickBooks, see eFAACT User Manual "Send Journal Entry" for details</li>
        </ol>
    </ng-template>
</p-messages>
<p-messages></p-messages>
<p-accordion [multiple]="true" *efLet="selectedPayPeriod$ | async as payPeriod">
    <p-accordionTab [selected]="true" header="Pay Periods">
        <div style="height: 50vh; width: 90vw">
            <ef-payroll-export-presenter
                [items]="payPeriods$ | async"
                [Payrolls]="export$ | async"
                (View)="onView($event)"
                (Send)="onSend($event)"
                (Sync)="onSync($event)"
                (Refresh)="onRefresh($event)"
                [selectedError]="selectedErrorWithStatus$ | async"
                (ShowError)="ShowErrorSubject.next($event)"
            >
            </ef-payroll-export-presenter>
        </div>
    </p-accordionTab>
    <p-accordionTab [selected]="!!payPeriod">
        <ng-template #header *ngIf="payPeriod">{{
            payPeriod
                ? 'Selected Pay Period: ' +
                  moment(payPeriod.ScheduledEndDate).format('MM-DD-YYYY')
                : ''
        }}</ng-template>
        <ef-third-party-payroll-export
            [externalIntegration]="true"
            [items]="export$ | async"
            [payPeriodDates]="payPeriodDatesSelectItems$ | async"
            [fileFormats]="fileFormats$ | async"
            [startDate]="(userInfo$ | async).PrevPayPeriodStart"
            [endDate]="(userInfo$ | async).PrevPayPeriodEnd"
            [payrollExportFormat]="[]"
        ></ef-third-party-payroll-export>
    </p-accordionTab>
</p-accordion>
